import { render, staticRenderFns } from "./CsAsignacionContableFuncionarios.vue?vue&type=template&id=31344acb"
import script from "./CsAsignacionContableFuncionarios.vue?vue&type=script&lang=js"
export * from "./CsAsignacionContableFuncionarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports